import checkIcon from './assets/check.svg';
import errorIcon from './assets/error.svg';
import warningIcon from './assets/warning.svg';

export const TOAST_PROPERTIES = [

     {
        id: 41,
        type: 'success',
        className: 'success',
        label: 'Success',
        backgroundColor: '#5bc0de',
        description: "Success",
        icon: checkIcon
    },
    {
        id: 42,
        type: 'danger',
        className: 'danger',
        label: 'Danger',
        backgroundColor: '#FF5277',
        description: 'Danger',
        icon: errorIcon
    },
    {
        id: 43,
        type: 'info',
        className: 'info',
        label: 'Info',
        backgroundColor: 'lightgreen',
        description: 'Info',
        icon: warningIcon
    },
    {
        id: 44,
        type: 'warning',
        className: 'warning',
        label: 'Warning',
        backgroundColor: '#F0AD4E',
        description: 'Warning',
        icon: warningIcon
    },
];

// export const BUTTON_PROPS = [
//     // {
//     //     id: 1,
//     //     type: 'success',
//     //     className: 'success',
//     //     label: 'Success'
//     // },
//     // {
//     //     id: 2,
//     //     type: 'danger',
//     //     className: 'danger',
//     //     label: 'Danger'
//     // },
//     // {
//     //     id: 3,
//     //     type: 'info',
//     //     className: 'info',
//     //     label: 'Info'
//     // },
//     // {
//     //     id: 4,
//     //     type: 'warning',
//     //     className: 'warning',
//     //     label: 'Warning'
//     // },
// ];